import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { useLanguage } from '../context/LanguageContext';

function ForgotPassword() {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setMessage('');

    try {
      await api.post('/auth/forgot-password', { email });
      setStatus('success');
      setMessage(t('forgot_password_success'));
    } catch (err) {
      setStatus('error');
      setMessage(
        err.response?.data?.error || t('error_generic')
      );
    }
  };

  return (
    <div style={{
      display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh',
      background: 'var(--bg-apex)',
      backgroundImage: 'radial-gradient(circle at center, rgba(99, 102, 241, 0.05), transparent 70%)'
    }}>
      <div className="glass-card animate-fade" style={{ width: '100%', maxWidth: '440px', padding: '3rem' }}>

        {/* Logo & Title */}
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <div style={{
            background: 'var(--accent-primary)',
            width: '80px', height: '80px', borderRadius: '20px', display: 'inline-flex',
            alignItems: 'center', justifyContent: 'center', marginBottom: '2rem',
            boxShadow: 'var(--glow-indigo)'
          }}>
            <span style={{ fontWeight: 900, color: 'var(--btn-text)', fontSize: '2.5rem' }}>A</span>
          </div>
          <h2 style={{ fontSize: '2rem', color: 'var(--text-heading)', marginBottom: '0.75rem', letterSpacing: '-0.03em' }}>
            {t('forgot_password_title')}
          </h2>
          <p style={{ color: 'var(--text-body)', fontSize: '0.95rem', fontWeight: 500 }}>
            {t('forgot_password_subtitle')}
          </p>
        </div>

        {/* Success state */}
        {status === 'success' ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '64px', height: '64px', borderRadius: '50%',
              background: 'rgba(34, 197, 94, 0.15)', border: '2px solid rgba(34, 197, 94, 0.4)',
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              marginBottom: '1.5rem', fontSize: '1.75rem'
            }}>
              ✓
            </div>
            <div style={{
              background: 'rgba(34, 197, 94, 0.08)', border: '1px solid rgba(34, 197, 94, 0.2)',
              color: '#4ade80', padding: '1rem 1.25rem', borderRadius: '12px',
              marginBottom: '2rem', fontSize: '0.9rem', fontWeight: 500, lineHeight: 1.6
            }}>
              {message}
            </div>
            <Link to="/login" style={{
              display: 'inline-block', color: 'var(--accent-primary)',
              fontWeight: 700, fontSize: '0.9rem', textDecoration: 'none'
            }}>
              ← {t('back_to_login')}
            </Link>
          </div>
        ) : (
          <>
            {/* Error message */}
            {status === 'error' && (
              <div style={{
                background: 'rgba(244, 114, 182, 0.1)', border: '1px solid rgba(244, 114, 182, 0.2)',
                color: 'var(--accent-magenta)', padding: '1rem', borderRadius: '12px',
                marginBottom: '1.5rem', textAlign: 'center', fontSize: '0.85rem', fontWeight: 600
              }}>
                {message}
              </div>
            )}

            {/* Form */}
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                <label style={{
                  fontSize: '0.75rem', fontWeight: 700, color: 'var(--text-muted)',
                  textTransform: 'uppercase', letterSpacing: '0.05em', marginLeft: '0.5rem'
                }}>
                  {t('email_address')}
                </label>
                <input
                  className="cyber-input"
                  type="email"
                  placeholder="your@email.com"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={status === 'loading'}
                />
              </div>

              <button
                type="submit"
                className="btn-cyber"
                disabled={status === 'loading'}
                style={{ marginTop: '0.5rem', padding: '1.25rem', opacity: status === 'loading' ? 0.7 : 1 }}
              >
                {status === 'loading' ? t('sending') : t('send_link')}
              </button>
            </form>

            <div style={{ marginTop: '2rem', textAlign: 'center' }}>
              <Link to="/login" style={{
                color: 'var(--accent-primary)', fontWeight: 700,
                fontSize: '0.85rem', textDecoration: 'none'
              }}>
                ← {t('back_to_login')}
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
